/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfTagResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfTagResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /tags/search
 */
export interface SearchRequestBuilder extends BaseRequestBuilder<SearchRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfTagResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<SearchRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfTagResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SearchRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface SearchRequestBuilderGetQueryParameters {
    name?: string;
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const SearchRequestBuilderUriTemplate = "{+baseurl}/tags/search?name={name}{&page*,pageSize*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const SearchRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SearchRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfTagResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
